import { render, staticRenderFns } from "./Labor.vue?vue&type=template&id=49873eb0"
import script from "./Labor.vue?vue&type=script&lang=js"
export * from "./Labor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports